// extracted by mini-css-extract-plugin
export default {"viewer":"entidades-notificaciones-preview_viewer__KHcce"};